import { MutationKey } from '@tanstack/react-query';

import { CommonSuccess, GenericFailure } from '@playq/services-shared';
import { AppSupportRequest } from '@playq/services-beetle';
import { Environment } from '@playq/octopus-common';

import { useEitherMutation, UseMutationOptionsExtended } from '/api/service-hooks';

import { IBeetleId, IBeetleStatus } from './types';
import { methods } from './serviceHandlerRequest';
import { SupportContentType } from './types/supportContentType';

type UpdateStatusProps = { id: IBeetleId; status: IBeetleStatus; env: Environment };
export const updateStatusMutationKey: MutationKey = ['mutation', 'updateStatus'];

export const useUpdateStatus = (
  method: SupportContentType,
  options?: UseMutationOptionsExtended<CommonSuccess | AppSupportRequest, GenericFailure | Error, UpdateStatusProps>
) => {
  const request = methods(method);
  return useEitherMutation(({ id, status, env }) => request.updateStatus(id, status, env), {
    mutationKey: updateStatusMutationKey,
    ...options,
  });
};
